import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Tab from '../Tab';

function PageTab(props) {
  return /*#__PURE__*/React.createElement(Tab, _extends({}, props, {
    size: "lg"
  }));
}

export default PageTab;